var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7441 33.8096C28.6737 34.2779 29.7624 33.4465 29.5176 32.4033L27.0225 21.7812L35.3613 14.625C36.203 13.9027 35.7566 12.5234 34.6514 12.4307L23.668 11.5088L19.3877 1.50781C18.9549 0.49727 17.5216 0.497256 17.0889 1.50781L12.8076 11.5088L1.89844 12.4307C0.796144 12.5238 0.349137 13.8971 1.18555 14.6211L9.45312 21.7773L6.95996 32.4033C6.70722 33.4801 7.87391 34.3305 8.82129 33.7598L18.2383 28.0869L27.6553 33.7598L27.7441 33.8096Z",
    fill: "white",
    stroke: "#FFA402",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.e6e62b6efe76055f365380100e3c5de7.svg";
export { ForwardRef as ReactComponent };